import React, { forwardRef } from 'react'

import cn from 'classnames'

import styles from './BaseText.module.scss'
import { BaseTextProps } from './types'

const BaseText: React.FC<BaseTextProps> = forwardRef<HTMLElement, BaseTextProps>(
  ({
    size = 'default',
    Tag = 'p',
    className,
    markup,
    isSrOnly,
    isPreFormatted,
    isMarginless,
    hasEllipsis,
    hasFullWidth,
    alignment,
    lineClamp,
    hasDataTrackingPii,
    testId,
    ...props
  }) => (
    <Tag
      className={cn(
        styles.bodyText,
        styles[`bodyText_${size}`],
        isSrOnly && styles.bodyText_srOnly,
        isPreFormatted && styles.bodyText_preFormatted,
        isMarginless && styles.marginless,
        hasEllipsis && styles.ellipsis,
        hasFullWidth && styles.fullWidth,
        alignment && styles[alignment],
        lineClamp && styles[`lineClamp${lineClamp}`],
        className,
      )}
      {...(markup ? { dangerouslySetInnerHTML: { __html: markup } } : {})}
      data-tracking-pii={hasDataTrackingPii}
      data-testid={testId}
      {...props}
    />
  ),
)

export default BaseText
